import { render, staticRenderFns } from "./ItemCustomer.vue?vue&type=template&id=1f53c49e"
import script from "./ItemCustomer.vue?vue&type=script&lang=js"
export * from "./ItemCustomer.vue?vue&type=script&lang=js"
import style0 from "./ItemCustomer.vue?vue&type=style&index=0&id=1f53c49e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports